import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {
      "& .MuiPaper-root": {
        width: "100%",
        borderRadius: 16,
        position: "relative"
      },
      "& .MuiDialogTitle-root": {
        padding: "24px",
        textAlign: "center"
      },
      "& .MuiDialogContent-root": {
        marginTop: 8,
        padding: "0 24px",
        textAlign: "center"
      },
      "& .MuiDialogActions-root": {
        borderTop: 0,
        padding: "24px",
        columnGap: 16,
        justifyContent: "center",
        marginTop: 8
      },
      "& .MuiButton-root": {
        fontSize: "1.8rem",
        "& .MuiTypography-root": {
          fontSize: "1.8rem"
        }
      },
      "& .MuiTypography-h6": {
        width: "100%"
      },
      "& .MuiGrid-root": {
        padding: "2px 8px"
      }
    },
    dialogContent: {
      display: "flex",
      flexDirection: "column",
      gap: 16
    },
    btnAction: {
      height: 48,
      "&.MuiButton-containedPrimary .MuiTypography-root": {
        color: "#ffffff"
      }
    },
    typeButton: {
      height: 48,
      borderColor: "#009FB8",
      width: "40%",
      "&:hover": {
        borderColor: "#007B9E !important",
        background: "#f6f6f6ff !important"
      },
      "&:active": {
        border: "none",
        outline: "none"
      }
    },
    typeButtonSubmit: {
      background: "#009FB8 !important",
      width: "100%",
      "&:hover": {
        background: "#007B9E !important"
      }
    },
    dialogTitle: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      borderRadius: "16px 16px 0 0",
      width: "100%"
    },
    titleHeader: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "20px !important",
      fontWeight: 700
    },
    titleContainer: {
      fontWeight: 700,
      fontSize: "12px !important"
    },
    titleRowContainer: {
      fontWeight: 700,
      fontSize: "14px !important",
      textAlign: "start"
    },
    titleColContainer: {
      fontWeight: 400,
      fontSize: "16px !important",
      textAlign: "start"
    },
    titleNewContainer: {
      fontWeight: 700,
      fontSize: "14px !important",
      textAlign: "start",
      color: "#009FB8"
    },
    detailsContainer: {
      display: "flex",
      textAlign: "start",
      // gap: 4,
      "& p": {
        margin: "0 !important"
      }
    },
    newDataItem: {
      color: "#009FB8"
    },
    required: {
      color: "red"
    },
    inputBlock: {
      display: "flex",
      flexDirection: "column",
      gap: 2,
      marginTop: 16
    },
    btnClose: {
      color: "#009FB8 !important",
      fontSize: "14px !important",
      fontWeight: 700
    },
    btnSubmit: {
      color: theme.palette.common.white,
      fontSize: "14px !important",
      fontWeight: 700
    },
    lineLimit: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      "-webkit-line-clamp": 1,
      "-webkit-box-orient": "vertical",
      wordBreak: "break-all"
    },
    width600: {
      maxWidth: 600
    },
    width800: {
      "& .MuiDialog-container": {
        alignItems: "center",
        justifyContent: "center"
      },
      "& .MuiPaper-root": {
        maxWidth: 850,
        margin: "auto",
        position: "relative"
      }
    }
  }),
  { name: "DialogConfirmEdit" }
);

export default useStyles;
